(function () {
  function removeReturnsTab() {
    var host = document.querySelector('main');
    if (!host || !host.shadowRoot) return;

    if (!host.shadowRoot.querySelector('#kp-hide-returns-style')) {
      var style = document.createElement('style');
      style.id = 'kp-hide-returns-style';
      style.textContent = '[data-nav-path*="return"] { display: none !important; }';
      host.shadowRoot.appendChild(style);
    }

    var sidebar = host.shadowRoot.querySelector('#kp-sidebar-wrapper');
    if (!sidebar) return;
    sidebar.querySelectorAll('button[data-nav-path]').forEach(function (btn) {
      var path = (btn.getAttribute('data-nav-path') || '').toLowerCase();
      var text = (btn.textContent || '').toLowerCase();
      if (path.includes('return') || text.includes('my return')) {
        btn.remove();
      }
    });
  }

  window.addEventListener('SIDEBAR_LOADED', removeReturnsTab);
})();
